import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import * as React from 'react'
import SimplePullToRefresh from 'react-simple-pull-to-refresh'

type Props = React.ComponentProps<typeof SimplePullToRefresh>

const PullToRefresh: React.FC<Props> = ({ children, onRefresh, isPullable = true, ...others }) => {
  const { md } = useBreakpoint()

  return (
    <Choose>
      <When condition={!md && isPullable}>
        <SimplePullToRefresh
          onRefresh={onRefresh}
          pullingContent={null}
          isPullable={isPullable}
          {...others}>
          {children}
        </SimplePullToRefresh>
      </When>
      <Otherwise>{children}</Otherwise>
    </Choose>
  )
}

export default PullToRefresh
